jQuery(document).ready(function($) {
    'use strict';

    window.svmInitHotelMap({
        center: [window.hotel.coordinates.lng, window.hotel.coordinates.lat],
        isPromoted: !!window.hotel.is_promoted,
    });

    $(document.body).on('click', '.hotel-cta-trigger', function() {
        $(this).toggleClass('active');
        $('.hotel-cta-widget').toggleClass('active');
        $('html').toggleClass('hotel-booking-open');
    });

    $(document.body).on('click', '.hotel-cta-close', function() {
        $('.hotel-cta-trigger').removeClass('active');
        $('.hotel-cta-widget').removeClass('active');
        $('html').removeClass('hotel-booking-open');
    });

    var distance = $('.hotel-content').offset().top;

    $(window).scroll(function() {
        if ($(this).scrollTop() >= distance) {
            $('.hotel-menu').addClass('active');
        } else {
            $('.hotel-menu').removeClass('active');
        }
    });

    // Dölj menyval vars sektion inte renderats (t.ex. hotell utan faciliteter)
    $('.hotel-menu button').each(function() {
        if (!$(`.scroll-target[data-id="${$(this).attr('data-id')}"]`).length) {
            $(this).hide();
        }
    });

    $(document.body).on('click', '.hotel-menu button', function() {
        const target = parseFloat($(this).attr('data-id'));
        const current_target = parseFloat($('.hotel-content').attr('data-id'));

        let offsetModifier = 52;
        if (current_target >= target) {
            offsetModifier = 148;
        }

        const $scrollTarget = $(`.scroll-target[data-id="${target}"]`);

        if (!$scrollTarget.length) {
            return;
        }

        $('html, body').animate({
            scrollTop: $scrollTarget.offset().top - offsetModifier,
        });

        $('.hotel-content').attr('data-id', target);
    });
});
